import { Agent } from '@newrelic/browser-agent/loaders/agent'
import { Logging } from '@newrelic/browser-agent/features/logging'

// Referências ao console de verdade, guardadas antes do agente embrulhar console.*.
// Quem já envia o log por newrelic.log (window.log, captura global) escreve no console por aqui,
// senão a mesma mensagem chega duas vezes: uma pela captura do console e outra pela chamada explícita.
export const nativeConsole = {
    log: console.log.bind(console),
    warn: console.warn.bind(console),
    error: console.error.bind(console),
}

// Só nos domínios publicados. Localhost, IP da rede e ngrok nunca enviam.
function isPublishedHost() {
    return location.hostname === 'zandu.com.br' || location.hostname.endsWith('.zandu.com.br')
}

/**
 * Sobe o agente do New Relic Browser apenas com o recurso de logs: console.* e newrelic.log().
 *
 * O loader completo (o antigo snippet do index.html) mandava ajax, erros, tempos de página,
 * trace e sessão, e estourava o limite da conta. Aqui o agente é montado só com o Logging.
 * O PageViewEvent o agente inclui por conta própria e não dá para tirar: é a chamada inicial
 * (1 por carregamento) que devolve a configuração da conta, inclusive o nível de log aceito.
 *
 * O nível capturado do console e da API é definido no New Relic, nas configurações do app
 * Browser (Browser logs) — não aqui.
 */
export function startNewRelic() {
    if (!isPublishedHost()) return
    try {
        new Agent({
            features: [Logging],
            init: {
                privacy: { cookies_enabled: true },
                distributed_tracing: { enabled: false },
                // nenhum destes é carregado (features acima); desligados também na config por garantia
                ajax: { enabled: false, autoStart: false },
                jserrors: { enabled: false, autoStart: false },
                metrics: { enabled: false, autoStart: false },
                generic_events: { enabled: false, autoStart: false },
                page_action: { enabled: false },
                user_actions: { enabled: false },
                page_view_timing: { enabled: false, autoStart: false },
                session_trace: { enabled: false, autoStart: false },
                session_replay: { enabled: false, autoStart: false },
                soft_navigations: { enabled: false, autoStart: false },
                logging: { enabled: true, autoStart: true },
            },
            info: {
                beacon: 'bam.nr-data.net',
                errorBeacon: 'bam.nr-data.net',
                licenseKey: 'NRJS-84f360c3a075bd3f7ec',
                applicationID: '594514487',
                sa: 1,
            },
            loader_config: {
                accountID: '4021680',
                trustKey: '4021680',
                agentID: '594514487',
                licenseKey: 'NRJS-84f360c3a075bd3f7ec',
                applicationID: '594514487',
            },
        })
    } catch (error) {
        nativeConsole.warn('newrelic start failed', error)
    }
}
